<script setup>
import { inject } from 'vue'

import { schemaKey, valuesKey, errorsKey, fieldNameKey } from './symbols'

const schema = inject(schemaKey)
const values = inject(valuesKey)
const errors = inject(errorsKey)
const fieldName = inject(fieldNameKey)
</script>

<template>
  <input
    v-model="values[fieldName]"
    :id="fieldName"
    :class="{'has-errors': !!errors[fieldName]}"
    :required="schema && schema[fieldName].required"
    :maxLength="schema && schema[fieldName].max_length"
  >
</template>
